import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
`

export const TitleEl = styled.h2`
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  /* color: ${theme.colors.green2}; */
  font-size: 12px;
  /* color: ${theme.colors.gray500}; */
`
